import axios from '@/axiosInterceptor';

const state = () => ({});

// actions
const actions = {
  async uploadFile(_, payload) {
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/subscriptions/upload_file',
        payload
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      }
    }
  },
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations,
};
